import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Canvas from '../Canvas';
import canvasPropTypes, { pickProps, defaultProps } from '../Canvas/propTypes';
var Polygon = /*#__PURE__*/function (_Component) {
  function Polygon() {
    var _this;
    _classCallCheck(this, Polygon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Polygon, [].concat(args));
    _defineProperty(_this, "canvasRef", function (node) {
      _this.canvas = node;
    });
    _defineProperty(_this, "drawShape", function (coordinates) {
      if (coordinates.length === 0) return;
      var ctx = _this.canvas.canvasElement.getContext('2d');
      _this.canvas.setStrokeStyle();
      coordinates.forEach(function (item, index, array) {
        var nextCoordinate = array[index + 1];
        if (nextCoordinate !== void 0) {
          var initialCoord = null;
          if (index === 0) {
            initialCoord = item;
          }
          _this.__drawLine(initialCoord, nextCoordinate);
        }
      });
      _this.canvas.setFillStyle();
      ctx.fill();
    });
    _defineProperty(_this, "onMouseMove", function (e) {
      if (_this.canvas.isDrawing()) {
        _this.clearCanvas();
        var currentCoordinate = _this.canvas.getCurrentCoordinates(e);
        var lines = _this.props.coordinates.concat([currentCoordinate]); // add temporary coordinate

        // add initial coordinate at the end of the array to close the polygon
        if (lines.length > 2) {
          lines = lines.concat([lines[0]]);
        }
        _this.drawShape(lines);
      }
    });
    _defineProperty(_this, "onMouseOut", function (e) {
      if (_this.canvas.isDrawing()) {
        var initialCoordinate = _this.canvas.getInitialCoordinate();
        var newCoordinates = _this.props.coordinates.concat([initialCoordinate]);
        if (newCoordinates.length > 3) {
          _this.clearCanvas();
          _this.drawShape(newCoordinates);
          _this.canvas.stopDrawing(newCoordinates);
        }
      }
    });
    _defineProperty(_this, "onDoubleClick", function () {
      _this.clearCanvas();
      var initialCoordinate = _this.canvas.getInitialCoordinate();
      var newCoordinates = _this.props.coordinates.concat([initialCoordinate]);
      _this.drawShape(newCoordinates);
      if (_this.canvas.isDrawing()) {
        _this.canvas.stopDrawing(newCoordinates);
      }
    });
    _defineProperty(_this, "onClick", function (e) {
      if (_this.canvas.isDrawing()) {
        _this.clearCanvas();
        var currentCoordinate = _this.canvas.getCurrentCoordinates(e);
        var lastCoordinate = _this.canvas.getLastCoordinate();
        if (currentCoordinate.x === lastCoordinate.x && currentCoordinate.y === lastCoordinate.y) {
          return; // in case the user click at the same point, this click is discarded
        }
        var newCoordinates = _this.props.coordinates.concat([currentCoordinate]);
        _this.drawShape(newCoordinates);
        _this.props.handleSetCoordinates(newCoordinates, true);
      } else {
        _this.canvas.startDrawing(e);
      }
    });
    return _this;
  }
  _inherits(Polygon, _Component);
  return _createClass(Polygon, [{
    key: "__drawLine",
    value: function __drawLine(begin, end) {
      var ctx = this.canvas.canvasElement.getContext('2d');
      if (begin) {
        ctx.beginPath();
        ctx.moveTo(begin.x, begin.y);
      }
      ctx.lineTo(end.x, end.y);
      ctx.stroke();
    }

    // ===========
    //   ACTIONS
    // ===========
  }, {
    key: "clearCanvas",
    value: function clearCanvas() {
      var ctx = this.canvas.canvasElement.getContext('2d');
      ctx.clearRect(0, 0, this.canvas.canvasElement.width, this.canvas.canvasElement.height);
      ctx.beginPath();
      ctx.closePath();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Canvas, Object.assign({
        realRef: this.canvasRef,
        drawShape: this.drawShape,
        onMouseMove: this.onMouseMove,
        onMouseOut: this.onMouseOut,
        onDoubleClick: this.onDoubleClick,
        onClick: this.onClick
      }, pickProps(this.props)));
    }
  }]);
}(Component);
_defineProperty(Polygon, "propTypes", canvasPropTypes);
_defineProperty(Polygon, "defaultProps", defaultProps);
export { Polygon as default };